<template>
  <v-app-bar app>
    <div
      class="d-flex justify-space-between text-center"
      style="width:100%"
    >
      <v-img
        :class="hasProfile ? 'cursor-pointer' : null"
        :src="logo.src"
        max-width="120"
        contain
        @click="hasProfile ? handleLogoClick(logo) : null"
      />

      <v-spacer />

      <v-app-bar-nav-icon
        @click.stop="onClickBtn"
        v-show="hasProfile"
      />
    </div>
  </v-app-bar>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import { trackRiverflexLeftHeaderLogoTap, trackRiverflexCenterHeaderLogoTap } from '@/segmentAnalytics/common'

interface ILogo {
  to: string
  src: string
}

@Component
export default class TopBar extends Vue {
  @Prop() hasProfile: boolean

  logo: ILogo = {
    to: '/home',
    src: require('@/assets/images/logo.svg')
  }

  setDrawer (value: boolean) {
    this.$store.commit('setDrawer', value)
  }

  toggleDrawer () {
    this.$store.commit('toggleDrawer')
  }

  onClickBtn () {
    this.setDrawer(!this.$store.state.drawer)
  }

  handleLogoClick (logo: ILogo, position: string) {
    if (position === 'left') {
      trackRiverflexLeftHeaderLogoTap()
    } else {
      trackRiverflexCenterHeaderLogoTap()
    }
    this.go(logo.to)
  }

  go (path: string) {
    this.$router.push(path)
  }
}
</script>
